import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPublicServices, StateStatus } from '@guryou/redux';

const usePublicServices = (stateSelector, providerId) => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(stateSelector);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getPublicServices(providerId));
    }
  }, [dispatch, providerId, status]);

  return { data: data || [], status, version, entity };
};

export default usePublicServices;
